// ** Gatsby
import { PortableText } from "@portabletext/react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import Text from "../Text"

// ** Utils
import { serializers } from "../Serializers"
import Button from "../Button"

// ** Helpers
import { classNames, parseLink } from "../../utils/helpers"

const SectionHomepageHero = ({ section }: any) => {
  const {
    listItems,
    secondaryListItems,
    _rawContent: content,
    background,
  } = section

  return (
    <Box className="flex flex-col gap-6 lg:gap-y-12">
      <Container
        className="pt-10 lg:pt-12 lg:flex lg:flex-row-reverse lg:gap-10 lg:items-center"
        fullWidthOnMobile={false}
        constrainedToBreakPoint
      >
        <Box className="hidden lg:flex w-full lg:basis-[45%] lg:pt-4 pb-4 ">
          <GatsbyImage
            image={background?.Image?.asset?.gatsbyImageData}
            alt={background?.Image?.asset?.altText || "Hero"}
          />
        </Box>
        <Box className="text-gray-700 text-center lg:flex-1 lg:text-left">
          <Box className="px-4 lg:px-0 [&>h1]:mb-0 [&>p]:hidden [&>p]:lg:block [&>p]:fluid-lg [&>p]:mt-4 [&>p]:lg:mt-8 [&>p]:lg:mb-10">
            <PortableText components={serializers} value={content} />
          </Box>
          <Box className="hidden mt-6 px-6 md:px-0 lg:grid grid-cols-2 xl:flex lg:justify-between gap-2">
            {listItems.map((item: any, idx: any) => (
              <Text
                key={idx}
                variant="extra-small"
                className="flex items-center gap-2 whitespace-nowrap"
              >
                <CheckMark /> {item.title}
              </Text>
            ))}
          </Box>
        </Box>
      </Container>
      <Container
        fullWidthOnMobile={false}
        className="flex flex-col w-full gap-2 lg:flex-row my-0 px-10 sm:px-40 lg:px-0 mx-auto md:pt-0 md:mt-0 lg:max-w-4xl lg:justify-between lg:gap-10"
      >
        {secondaryListItems.map((item: any, idx: any) => (
          <Link key={idx} to={parseLink(item.linkPrimary)} className="lg:w-1/2">
            <Button
              className={classNames(
                idx === 0
                  ? "bg-blue-500 hover:bg-blue-900"
                  : "bg-orange-500 hover:bg-yellow-600",
                "text-white text-center my-2 md:my-0 lg:hover:shadow-xl lg:shadow-md py-5 lg:py-[30px] lg:px-[10px]"
              )}
            >
              <Text variant="large">{item.linkPrimary?.title}</Text>
            </Button>
          </Link>
        ))}
      </Container>
      <Container
        fullWidthOnMobile={false}
        className="lg:hidden flex flex-col w-full gap-2 lg:flex-row mt-8 mx-auto md:pt-0 md:mt-0 lg:max-w-5xl lg:justify-between lg:gap-10"
      >
        <Box className="lg:basis-[52%] lg:pt-4 pb-4 ">
          <Box className="text-gray-700 text-center pb-4 lg:flex-1 lg:text-left">
            <Box className="block lg:hidden px-8 lg:px-0">
              <Box className="lg:px-4 [&>h1]:mb-0 [&>h1]:hidden [&>p]:fluid-lg">
                <PortableText components={serializers} value={content} />
              </Box>
            </Box>
            <Box className="mt-12 px-6 md:px-20 lg:px-0 grid grid-cols-2 lg:flex lg:justify-between gap-2">
              {listItems.map((item: any, idx: any) => (
                <Box
                  key={idx}
                  className="overflow-hidden flex items-center gap-2 whitespace-nowrap"
                >
                  <Box className="w-4 h-4">
                    <CheckMark />
                  </Box>
                  <Text variant="extra-small">{item.title}</Text>
                </Box>
              ))}
            </Box>
          </Box>
          <GatsbyImage
            image={background?.Image?.asset?.gatsbyImageData}
            alt={background?.Image?.asset?.altText || "Hero"}
            className="mt-20"
          />
        </Box>
      </Container>
    </Box>
  )
}

export const CheckMark = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="w-4 h-4 text-white p-0.5 bg-orange-500 rounded-full"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.5 12.75l6 6 9-13.5"
    />
  </svg>
)

export default SectionHomepageHero
